export const MIS_GET_ALL = "MIS_GET_ALL";

export const MIS_GET_ALL_PENDING = "MIS_GET_ALL_PENDING";

export const MIS_GET_ALL_SUCCESS = "MIS_GET_ALL_SUCCESS";

export const MIS_GET_ALL_ERROR = "MIS_GET_ALL_ERROR";
